module.exports = global["jwplayer"] = require("-!/mnt/jenkins/var-lib-jenkins/jobs/animoto_player_deploy/workspace/node_modules/string-replace-webpack-plugin/loader.js?id=luhfwtsro3gtlnmi!/mnt/jenkins/var-lib-jenkins/jobs/animoto_player_deploy/workspace/vendor/jwplayer.js");


/*****************
 ** WEBPACK FOOTER
 ** ./vendor/jwplayer.js
 ** module id = 2
 ** module chunks = 0
 **/